import { t } from '../i18n';

// 骰子类型枚举
export enum DiceType {
  NORMAL = 'NORMAL',
  CAVIER_1 = 'CAVIER_1',
  CAVIER_2 = 'CAVIER_2',
  CAVIER_3 = 'CAVIER_3',
  CAVIER_4 = 'CAVIER_4',
  CAVIER_5 = 'CAVIER_5',
  CAVIER_6 = 'CAVIER_6',
  ADULT = 'ADULT',
  EVEN = 'EVEN',
  ODD = 'ODD',
  HEAVEN = 'HEAVEN',
  DEMON_LU = 'DEMON_LU',
  DEMON_XI = 'DEMON_XI',
  DEMON_FA = 'DEMON_FA',
  LUCKY = 'LUCKY',
  SMALL_LUCKY = 'SMALL_LUCKY',
  MINI = 'MINI',
  CLOTHED = 'CLOTHED',
  RIGGED = 'RIGGED',
  UNPOPULAR = 'UNPOPULAR',
  UNLUCKY = 'UNLUCKY',
  TRIPLE_THREE = 'TRIPLE_THREE',
  CAVI_C = 'KAVI_C',
  ANGEL_AN = 'ANGEL_AN',
  ANGEL_JI = 'ANGEL_JI',
  ANGEL_LA = 'ANGEL_LA',
  ANTIOCH = 'ANTIOCH',
  LOADED = 'LOADED',
  KNIGHT = 'KNIGHT'
}

// 骰子数据接口
export interface DiceData {
  type: DiceType;
  nameKey: string;
  descKey: string;
  price: number;
  canBeSold: boolean;
  canBePurchased: boolean;
  dropRate: number;
  maxOwned: number;
  backgroundColor: string;
  textColor: string;
  probabilities: {
    [key: number]: number;
  };
}

// 骰子数据集合
export const DICE_DATA: { [key in DiceType]: DiceData } = {
  [DiceType.NORMAL]: {
    type: DiceType.NORMAL,
    nameKey: 'dice.NORMAL.name',
    descKey: 'dice.NORMAL.desc',
    price: 0,
    canBeSold: false,
    canBePurchased: true,
    dropRate: 0,
    maxOwned: 999,
    backgroundColor: '#ffffff',
    textColor: '#000000',
    probabilities: { 1: 1/6, 2: 1/6, 3: 1/6, 4: 1/6, 5: 1/6, 6: 1/6 }
  },
  [DiceType.CAVIER_1]: {
    type: DiceType.CAVIER_1,
    nameKey: 'dice.CAVIER_1.name',
    descKey: 'dice.CAVIER_1.desc',
    price: 20,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.001,
    maxOwned: 1,
    backgroundColor: '#e74c3c',
    textColor: '#000000',
    probabilities: { 1: 1, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0 }
  },
  [DiceType.CAVIER_2]: {
    type: DiceType.CAVIER_2,
    nameKey: 'dice.CAVIER_2.name',
    descKey: 'dice.CAVIER_2.desc',
    price: 20,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.002,
    maxOwned: 1,
    backgroundColor: '#e67e22',
    textColor: '#000000',
    probabilities: { 1: 0, 2: 1, 3: 0, 4: 0, 5: 0, 6: 0 }
  },
  [DiceType.CAVIER_3]: {
    type: DiceType.CAVIER_3,
    nameKey: 'dice.CAVIER_3.name',
    descKey: 'dice.CAVIER_3.desc',
    price: 20,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.003,
    maxOwned: 1,
    backgroundColor: '#f1c40f',
    textColor: '#000000',
    probabilities: { 1: 0, 2: 0, 3: 1, 4: 0, 5: 0, 6: 0 }
  },
  [DiceType.CAVIER_4]: {
    type: DiceType.CAVIER_4,
    nameKey: 'dice.CAVIER_4.name',
    descKey: 'dice.CAVIER_4.desc',
    price: 20,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.004,
    maxOwned: 1,
    backgroundColor: '#2ecc71',
    textColor: '#000000',
    probabilities: { 1: 0, 2: 0, 3: 0, 4: 1, 5: 0, 6: 0 }
  },
  [DiceType.CAVIER_5]: {
    type: DiceType.CAVIER_5,
    nameKey: 'dice.CAVIER_5.name',
    descKey: 'dice.CAVIER_5.desc',
    price: 20,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.001,
    maxOwned: 1,
    backgroundColor: '#3498db',
    textColor: '#000000',
    probabilities: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 1, 6: 0 }
  },
  [DiceType.CAVIER_6]: {
    type: DiceType.CAVIER_6,
    nameKey: 'dice.CAVIER_6.name',
    descKey: 'dice.CAVIER_6.desc',
    price: 20,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.006,
    maxOwned: 1,
    backgroundColor: '#9b59b6',
    textColor: '#000000',
    probabilities: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 1 }
  },
  [DiceType.ADULT]: {
    type: DiceType.ADULT,
    nameKey: 'dice.ADULT.name',
    descKey: 'dice.ADULT.desc',
    price: 600,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.0005,
    maxOwned: 6,
    backgroundColor: '#8e44ad',
    textColor: '#000000',
    probabilities: { 1: 0.385, 2: 0.077, 3: 0.077, 4: 0.077, 5: 0.154, 6: 0.23 }
  },
  [DiceType.EVEN]: {
    type: DiceType.EVEN,
    nameKey: 'dice.EVEN.name',
    descKey: 'dice.EVEN.desc',
    price: 88,
    canBeSold: true,
    canBePurchased: true,
    dropRate: 0.09,
    maxOwned: 99,
    backgroundColor: '#3498db',
    textColor: '#000000',
    probabilities: { 1: 0.067, 2: 0.267, 3: 0.067, 4: 0.267, 5: 0.067, 6: 0.267 }
  },
  [DiceType.ODD]: {
    type: DiceType.ODD,
    nameKey: 'dice.ODD.name',
    descKey: 'dice.ODD.desc',
    price: 99,
    canBeSold: true,
    canBePurchased: true,
    dropRate: 0.08,
    maxOwned: 99,
    backgroundColor: '#e74c3c',
    textColor: '#000000',
    probabilities: { 1: 0.217, 2: 0.117, 3: 0.217, 4: 0.117, 5: 0.217, 6: 0.117 }
  },
  [DiceType.HEAVEN]: {
    type: DiceType.HEAVEN,
    nameKey: 'dice.HEAVEN.name',
    descKey: 'dice.HEAVEN.desc',
    price: 10000,
    canBeSold: false,
    canBePurchased: false,
    dropRate: 0.0004,
    maxOwned: 1,
    backgroundColor: '#000000',
    textColor: '#ffffff',
    probabilities: { 1: 0.368, 2: 0.105, 3: 0.105, 4: 0.105, 5: 0.105, 6: 0.211 }
  },
  [DiceType.KNIGHT]: {
    type: DiceType.KNIGHT,
    nameKey: 'dice.KNIGHT.name',
    descKey: 'dice.KNIGHT.desc',
    price: 769,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.015,
    maxOwned: 6,
    backgroundColor: '#ffc0cb',
    textColor: '#ffffff',
    probabilities: { 1: 0.329, 2: 0.125, 3: 0.125, 4: 0.125, 5: 0.125, 6: 0.171 }
  },
  [DiceType.LUCKY]: {
    type: DiceType.LUCKY,
    nameKey: 'dice.LUCKY.name',
    descKey: 'dice.LUCKY.desc',
    price: 777,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.007,
    maxOwned: 3,
    backgroundColor: '#90EE90',
    textColor: '#000000',
    probabilities: { 1: 0.333, 2: 0, 3: 0.056, 4: 0.056, 5: 0.333, 6: 0.222 }
  },
  [DiceType.SMALL_LUCKY]: {
    type: DiceType.SMALL_LUCKY,
    nameKey: 'dice.SMALL_LUCKY.name',
    descKey: 'dice.SMALL_LUCKY.desc',
    price: 77,
    canBeSold: true,
    canBePurchased: true,
    dropRate: 0.07,
    maxOwned: 3,
    backgroundColor: '#2ecc71',
    textColor: '#000000',
    probabilities: { 1: 0.273, 2: 0.045, 3: 0.091, 4: 0.136, 5: 0.182, 6: 0.273 }
  },
  [DiceType.MINI]: {
    type: DiceType.MINI,
    nameKey: 'dice.MINI.name',
    descKey: 'dice.MINI.desc',
    price: 216,
    canBeSold: true,
    canBePurchased: true,
    dropRate: 0.05,
    maxOwned: 3,
    backgroundColor: '#95a5a6',
    textColor: '#000000',
    probabilities: { 1: 0.222, 2: 0.111, 3: 0.111, 4: 0.111, 5: 0.111, 6: 0.333 }
  },
  [DiceType.CLOTHED]: {
    type: DiceType.CLOTHED,
    nameKey: 'dice.CLOTHED.name',
    descKey: 'dice.CLOTHED.desc',
    price: 50,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.05,
    maxOwned: 99,
    backgroundColor: '#e67e22',
    textColor: '#ffffff',
    probabilities: { 1: 0.25, 2: 0.125, 3: 0.125, 4: 0.125, 5: 0.188, 6: 0.188 }
  },
  [DiceType.RIGGED]: {
    type: DiceType.RIGGED,
    nameKey: 'dice.RIGGED.name',
    descKey: 'dice.RIGGED.desc',
    price: 50,
    canBeSold: true,
    canBePurchased: true,
    dropRate: 0.1,
    maxOwned: 99,
    backgroundColor: '#7f8c8d',
    textColor: '#000000',
    probabilities: { 1: 0.23, 2: 0.374, 3: 0.083, 4: 0.083, 5: 0.147, 6: 0.083 }
  },
  [DiceType.UNPOPULAR]: {
    type: DiceType.UNPOPULAR,
    nameKey: 'dice.UNPOPULAR.name',
    descKey: 'dice.UNPOPULAR.desc',
    price: 15,
    canBeSold: true,
    canBePurchased: true,
    dropRate: 0.1,
    maxOwned: 99,
    backgroundColor: '#bdc3c7',
    textColor: '#000000',
    probabilities: { 1: 0.091, 2: 0.273, 3: 0.182, 4: 0.182, 5: 0.182, 6: 0.091 }
  },
  [DiceType.UNLUCKY]: {
    type: DiceType.UNLUCKY,
    nameKey: 'dice.UNLUCKY.name',
    descKey: 'dice.UNLUCKY.desc',
    price: 555,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.05,
    maxOwned: 99,
    backgroundColor: '#34495e',
    textColor: '#ffffff',
    probabilities: { 1: 0.045, 2: 0.227, 3: 0.227, 4: 0.227, 5: 0.227, 6: 0.045 }
  },
  [DiceType.TRIPLE_THREE]: {
    type: DiceType.TRIPLE_THREE,
    nameKey: 'dice.TRIPLE_THREE.name',
    descKey: 'dice.TRIPLE_THREE.desc',
    price: 333,
    canBeSold: true,
    canBePurchased: true,
    dropRate: 0.03,
    maxOwned: 99,
    backgroundColor: '#16a085',
    textColor: '#000000',
    probabilities: { 1: 0.182, 2: 0.227, 3: 0.455, 4: 0.045, 5: 0.045, 6: 0.045 }
  },
  [DiceType.CAVI_C]: {
    type: DiceType.CAVI_C,
    nameKey: 'dice.KAVI_C.name',
    descKey: 'dice.KAVI_C.desc',
    price: 20,
    canBeSold: true,
    canBePurchased: true,
    dropRate: 0.1,
    maxOwned: 99,
    backgroundColor: '#1abc9c',
    textColor: '#000000',
    probabilities: { 1: 0.111, 2: 0.444, 3: 0.111, 4: 0.111, 5: 0.111, 6: 0.111 }
  },
  [DiceType.ANTIOCH]: {
    type: DiceType.ANTIOCH,
    nameKey: 'dice.ANTIOCH.name',
    descKey: 'dice.ANTIOCH.desc',
    price: 3333,
    canBeSold: true,
    canBePurchased: true,
    dropRate: 0.03,
    maxOwned: 3,
    backgroundColor: '#9A582D',
    textColor: '#683C28',
    probabilities: { 1: 0, 2: 0, 3: 1, 4: 0, 5: 0, 6: 0 }
  },
  [DiceType.LOADED]: {
    type: DiceType.LOADED,
    nameKey: 'dice.LOADED.name',
    descKey: 'dice.LOADED.desc',
    price: 1111,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.01,
    maxOwned: 1,
    backgroundColor: '#34495e',
    textColor: '#000000',
    probabilities: { 1: 0.61, 2: 0.08, 3: 0.08, 4: 0.08, 5: 0.08, 6: 0.08 }
  },
  [DiceType.ANGEL_AN]: {
    type: DiceType.ANGEL_AN,
    nameKey: 'dice.ANGEL_AN.name',
    descKey: 'dice.ANGEL_AN.desc',
    price: 111,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.01,
    maxOwned: 1,
    backgroundColor: '#e6f7ff',
    textColor: '#0066cc',
    probabilities: { 1: 0.13, 2: 0.13, 3: 0.13, 4: 0.13, 5: 0.214, 6: 0.266 }
  },
  [DiceType.ANGEL_JI]: {
    type: DiceType.ANGEL_JI,
    nameKey: 'dice.ANGEL_JI.name',
    descKey: 'dice.ANGEL_JI.desc',
    price: 222,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.02,
    maxOwned: 1,
    backgroundColor: '#fff1e6',
    textColor: '#cc6600',
    probabilities: { 1: 0.13, 2: 0.13, 3: 0.13, 4: 0.13, 5: 0.214, 6: 0.266 }
  },
  [DiceType.ANGEL_LA]: {
    type: DiceType.ANGEL_LA,
    nameKey: 'dice.ANGEL_LA.name',
    descKey: 'dice.ANGEL_LA.desc',
    price: 333,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.03,
    maxOwned: 1,
    backgroundColor: '#f0e6ff',
    textColor: '#6600cc',
    probabilities: { 1: 0.13, 2: 0.13, 3: 0.13, 4: 0.13, 5: 0.214, 6: 0.266 }
  },
  [DiceType.DEMON_LU]: {
    type: DiceType.DEMON_LU,
    nameKey: 'dice.DEMON_LU.name',
    descKey: 'dice.DEMON_LU.desc',
    price: 111,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.01,
    maxOwned: 1,
    backgroundColor: '#c0392b',
    textColor: '#000000',
    probabilities: { 1: 0.13, 2: 0.13, 3: 0.13, 4: 0.13, 5: 0.13, 6: 0.348 }
  },
  [DiceType.DEMON_XI]: {
    type: DiceType.DEMON_XI,
    nameKey: 'dice.DEMON_XI.name',
    descKey: 'dice.DEMON_XI.desc',
    price: 222,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.02,
    maxOwned: 1,
    backgroundColor: '#c0392b',
    textColor: '#000000',
    probabilities: { 1: 0.13, 2: 0.13, 3: 0.13, 4: 0.13, 5: 0.13, 6: 0.348 }
  },
  [DiceType.DEMON_FA]: {
    type: DiceType.DEMON_FA,
    nameKey: 'dice.DEMON_FA.name',
    descKey: 'dice.DEMON_FA.desc',
    price: 333,
    canBeSold: true,
    canBePurchased: false,
    dropRate: 0.03,
    maxOwned: 1,
    backgroundColor: '#c0392b',
    textColor: '#000000',
    probabilities: { 1: 0.13, 2: 0.13, 3: 0.13, 4: 0.13, 5: 0.13, 6: 0.348 }
  }
};

// 辅助函数：获取骰子名称（国际化）
export const getDiceName = (type: DiceType): string => {
  return t(DICE_DATA[type].nameKey);
};

// 辅助函数：获取骰子描述（国际化）
export const getDiceDescription = (type: DiceType): string => {
  return t(DICE_DATA[type].descKey);
};

export const getDicePrice = (type: DiceType): number => {
  return DICE_DATA[type].price;
};

export const isDiceSellable = (type: DiceType): boolean => {
  return DICE_DATA[type].canBeSold;
};

export const getDiceBackgroundColor = (type: DiceType): string => {
  return DICE_DATA[type].backgroundColor;
};

export const getDiceTextColor = (type: DiceType): string => {
  return DICE_DATA[type].textColor;
};

export const getDiceProbabilities = (type: DiceType): { [key: number]: number } => {
  return DICE_DATA[type].probabilities;
};

export const getDiceSellPrice = (type: DiceType): number => {
  return Math.floor(DICE_DATA[type].price * 0.7);
};

export const rollDice = (type: DiceType): number => {
  const probabilities = DICE_DATA[type].probabilities;
  const random = Math.random();
  let sum = 0;

  for (let i = 1; i <= 6; i++) {
    sum += probabilities[i];
    if (random < sum) {
      return i;
    }
  }

  return 6;
};

export const isDicePurchasable = (type: DiceType): boolean => {
  return DICE_DATA[type].canBePurchased;
};

export const getDiceDropRate = (type: DiceType): number => {
  return DICE_DATA[type].dropRate;
};

export const getDiceMaxOwned = (type: DiceType): number => {
  return DICE_DATA[type].maxOwned;
};

export const getRandomRewardDice = (): DiceType | null => {
  const droppableDice = Object.values(DiceType).filter(type => DICE_DATA[type].dropRate > 0);

  if (droppableDice.length === 0) return null;

  const random = Math.random();
  let cumulativeProbability = 0;

  const diceWithProbabilities = droppableDice.map(type => ({
    type,
    probability: DICE_DATA[type].dropRate
  }));

  const totalProbability = diceWithProbabilities.reduce((sum, dice) => sum + dice.probability, 0);
  const normalizedDice = diceWithProbabilities.map(dice => ({
    ...dice,
    probability: dice.probability / totalProbability
  }));

  for (const dice of normalizedDice) {
    cumulativeProbability += dice.probability;
    if (random <= cumulativeProbability) {
      return dice.type;
    }
  }

  return normalizedDice[0].type;
};
